import React, { Component } from "react";
import { inject } from "mobx-react";
import { Label, Tooltip, OverlayTrigger } from "react-bootstrap";

@inject("searchStore")
class MaintenanceAgencyLabel extends Component {
  render() {
    const { maintenanceAgencyId } = this.props;
    const { getAllMaintenanceAgencies } = this.props.searchStore;
    const agencies = getAllMaintenanceAgencies;

    const agency = agencies.find(
      (a) =>
        a.maintenanceAgencyId?.toLowerCase() ===
        maintenanceAgencyId?.toLowerCase()
    );
    const maintenanceAgencyName = agency ? agency.name : maintenanceAgencyId;

    const agencyIdLower = maintenanceAgencyId?.toLowerCase();

    const tooltip = (
      <Tooltip id="tooltip-maintenance-agency">{maintenanceAgencyName}</Tooltip>
    );

    return (
      <OverlayTrigger placement="top" overlay={tooltip}>
        <Label
          className={`object-maintainer ${
            agencyIdLower === "ecb" ? "ecb" : ""
          }`}
          bsStyle="default"
        >
          {maintenanceAgencyId}
        </Label>
      </OverlayTrigger>
    );
  }
}

export default MaintenanceAgencyLabel;
